const UNPUBLISHED_STORY_PREFIXES = [
  'First_1000_Characters_Course/Intermediate/',
  'First_1000_Characters_Course/Upper_Intermediate/',
  'First_1000_Characters_Course/Advanced/',
];

export const isPublishedStoryFile = (file) => (
  typeof file === 'string'
  && !UNPUBLISHED_STORY_PREFIXES.some(prefix => file.startsWith(prefix))
);

export const isPublishedStory = (entry) => (
  Boolean(entry)
  && !entry.disabled
  && isPublishedStoryFile(entry.file)
);